import React, { useState, useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { Panel, Row, Table, Col } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { doneLoading, startLoading } from '../../utils/loading'
import pathname from '../../constants/pathname'
import InputForm from '../../components/forms/input/InputForm'
import { Controller, useForm } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import InputSelectForm from '../../components/forms/input/InputSelectForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import InputDateForm from '../../components/forms/input/InputDateForm'
import moment from 'moment'
import { DD_MM_YYYY_SLASH, REQUEST_DATE_FORMAT } from '../../constants/date'
import { TEMP_FORM_ID } from '../../constants/constants'
import { sessionGetItemStr } from '../../utils/sessionHelpers'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { saveManageProposalForm } from '../../redux/actions/subProjectFormSetting'
import notification from '../../utils/notification'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function TempletDetailFormWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { schema, buttonText } = props
  const [isLoading, setIsLoading] = useState(false)
  const [request, setRequest] = useState()
  const [isConfirmSave, setIsConfirmSave] = useState()
  const [isConfirmSaveDraft, setIsConfirmSaveDraft] = useState()

  const dispatch = useDispatch()
  let history = useHistory()

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)

  const formId = sessionGetItemStr(TEMP_FORM_ID)

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef, windowWidth])

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      id: formId,
      templateName: data.templateName,
      refTemplate: data.refTemplate,
      startDate: moment(data.startDate).format(REQUEST_DATE_FORMAT) || null,
      endDate: moment(data.endDate).format(REQUEST_DATE_FORMAT) || null,
      active: data.active,
    }

    setRequest(request)
    setIsConfirmSave(true)
  }

  const onSubmitDraft = (data) => {
    // console.log('data', data)

    let request = {
      id: formId,
      templateName: data.templateName,
      refTemplate: data.refTemplate,
      startDate: moment(data.startDate).format(REQUEST_DATE_FORMAT) || null,
      endDate: moment(data.endDate).format(REQUEST_DATE_FORMAT) || null,
      active: data.active,
    }

    setRequest(request)
    setIsConfirmSaveDraft(true)
  }

  const handleSave = async () => {
    // console.log('handleSave : ', request)
    setIsConfirmSave(false)
    setIsConfirmSaveDraft(false)
    setIsLoading(true)
    startLoading()
    try {
      const response = await saveManageProposalForm(formId, request)

      if (response?.projectTemplete) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 2500,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }
    setRequest('')
    doneLoading()
    setIsLoading(false)
  }

  const onEdit = (id) => {
    history.push({
      pathname: pathname.subProjectNew.settingProposal.projectName,
    })
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <div ref={containerRef}>
        <Panel
          // key={item.id}
          header={schema.header}
          bordered
          collapsible
          defaultExpanded
          shaded
          style={{ marginBottom: 20 }}
        >
          {
            //enableEdit
            !schema.disabled ? (
              <>
                <Row>
                  <Col>
                    <InputForm
                      schema={schema.inputForm.templateName}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>

                  {schema.inputForm.refTemplate && (
                    <Col>
                      <InputSelectForm
                        schema={schema.inputForm.refTemplate}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      />
                    </Col>
                  )}

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <InputDateForm
                      schema={schema.inputForm.startDate}
                      value={moment(schema.inputForm.startDate.value, DD_MM_YYYY_SLASH)
                        .add(-543, 'y')
                        .toDate()}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <InputDateForm
                      schema={schema.inputForm.endDate}
                      value={moment(schema.inputForm.endDate.value, DD_MM_YYYY_SLASH)
                        .add(-543, 'y')
                        .toDate()}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                    />
                  </Col>
                </Row>
                {/* <Row>
                  {schema?.inputForm.active && (
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <div style={{ marginTop: 10 }}>
                        <Controller
                          key={schema.inputForm.active.name}
                          name={schema.inputForm.active.name}
                          control={control}
                          rules={isValidators(schema.inputForm.active.validators)}
                          defaultValue={schema.inputForm.active.value == '1'}
                          //value={inputValue}
                          render={(props) => {
                            return (
                              <div style={{ marginTop: 10 }}>
                                <p>
                                  {requiredFiled(
                                    schema.inputForm.active.validators,
                                    `${schema.inputForm.active.label}`
                                  )}
                                </p>
                                <Toggle
                                  defaultChecked={schema.inputForm.active.value == '1'}
                                  size="lg"
                                  checkedChildren={'Active'}
                                  unCheckedChildren="Inactive"
                                  onChange={(value) => {
                                    // console.log(value)
                                    props.onChange(value)
                                  }}
                                />
                              </div>
                            )
                          }}
                        />
                      </div>
                    </Col>
                  )}
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <div style={{ marginTop: 10 }}>
                      <p>
                        <label>เวอร์ชัน : </label>
                        <label>{schema.version}</label>
                      </p>
                    </div>
                  </Col>
                </Row> */}
              </>
            ) : (
              <>
                <Row>
                  <Col>
                    <p>
                      <label style={{ fontWeight: 650 }}>
                        {schema.inputForm.templateName.label} :{' '}
                      </label>
                      <label>{schema.inputForm.templateName.value}</label>
                    </p>
                  </Col>

                  <Col lg={12} md={12} sm={24} xs={24}>
                    <p>
                      <label style={{ fontWeight: 650 }}>
                        {schema.inputForm.startDate.label} :{' '}
                      </label>
                      <label>{schema.inputForm.startDate.value}</label>
                    </p>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <p>
                      <label style={{ fontWeight: 650 }}>{schema.inputForm.endDate.label} : </label>
                      <label>{schema.inputForm.endDate.value}</label>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <div style={{ marginTop: 10 }}>
                      <p>
                        <label style={{ fontWeight: 650 }}>
                          {schema.inputForm.active.label} :{' '}
                        </label>
                        <label>
                          {schema.inputForm.active.value == '1' ? 'Active' : 'InActive'}
                        </label>
                      </p>
                    </div>
                  </Col>
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <div style={{ marginTop: 10 }}>
                      <p>
                        <label style={{ fontWeight: 650 }}>เวอร์ชัน : </label>
                        <label>{schema.version}</label>
                      </p>
                    </div>
                  </Col>
                </Row>
              </>
            )
          }

          <hr />
          <div className="right">
            {/* {enableEdit ? (
              <> */}

            {!schema.disabled && (
              <>
                <SaveButton
                  children="บันทึกร่าง"
                  disabled={isLoading}
                  onClick={handleSubmit(onSubmitDraft)}
                />
                <SaveButton
                  children="บันทึก"
                  disabled={isLoading}
                  onClick={handleSubmit(onSubmit)}
                />
                <CancelButton
                  children="ยกเลิก"
                  onClick={() => {
                    // setIsAdd(false)
                  }}
                />
              </>
            )}

            {/* </>
            ) : (
              <EditButton
                children="เปิดการแก้ไข"
                onClick={() => {
                  setIsConfirmEdit(true)
                }}
              />
            )} */}
          </div>
        </Panel>

        <Panel
          header={'ประวัติเวอร์ชันประเด็น'}
          bordered
          collapsible
          defaultExpanded
          shaded
          style={{ marginBottom: 20 }}
        >
          <Table wordWrap autoHeight data={schema.value} style={{ marginTop: -10 }}>
            <Column width={90} align="center">
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column minWidth={350} width={500} flexGrow={1}>
              <HeaderCell>
                <p>ชื่อประเด็น</p>
              </HeaderCell>
              <Cell dataKey="name" />
            </Column>
            <Column width={150}>
              <HeaderCell>
                <p>สำนัก</p>
              </HeaderCell>
              <Cell dataKey="department" />
            </Column>
            <Column width={250} align="center">
              <HeaderCell>
                <p>ช่วงเวลาที่เปิดรับ</p>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      {rowData.startDate || ''} - {rowData.endDate || ''}
                    </>
                  )
                }}
              </Cell>
            </Column>
            <Column width={120} align="center">
              <HeaderCell>
                <p>สถานะ</p>
              </HeaderCell>
              <Cell dataKey="statusName" />
            </Column>
            <Column width={100} align="center">
              <HeaderCell>
                <p>เวอร์ชัน</p>
              </HeaderCell>
              <Cell dataKey="version" />
            </Column>
          </Table>
        </Panel>

        <ConfirmWidget
          title={'ยืนยัน'}
          show={isConfirmSaveDraft}
          detail={`ยืนยันการบันทึกร่าง`}
          onCancle={() => {
            setIsConfirmSaveDraft(false)
            setRequest('')
          }}
          onConfirm={handleSave}
        />

        <ConfirmWidget
          title={'ยืนยัน'}
          show={isConfirmSave}
          detail={`ยืนยันการบันทึก กรณีที่สถานะการใช้งานเป็น Active จะไม่สามารถแก้ไขแบบฟอร์มใน เวอร์ชันเดิมได้อีก`}
          onCancle={() => {
            setIsConfirmSave(false)
            setRequest('')
          }}
          onConfirm={handleSave}
        />

        {/* <ConfirmWidget
          title={'ยืนยัน'}
          show={isConfirmEdit}
          detail={
            <>
              <p>ยืนยันเปิดการแก้ไข </p>
              <p style={{ marginTop: 10 }}>
                <i>*** การเปิดการแก้ไขจะเป็นการสร้างเวอร์ชันใหม่</i>
              </p>
            </>
          }
          onCancle={() => {
            setIsConfirmEdit(false)
            // setAddRequest('')
          }}
          onConfirm={() => {
            setEnableEdit(true)
            setIsConfirmEdit(false)
          }}
        /> */}
      </div>
    </>
  )
}
